module.exports = __webpack_public_path__ + "img/warning-outline.140f487a.svg";